import { render, staticRenderFns } from "./LedModel.vue?vue&type=template&id=7435f2c7"
import script from "./LedModel.vue?vue&type=script&lang=js"
export * from "./LedModel.vue?vue&type=script&lang=js"
import style0 from "./LedModel.vue?vue&type=style&index=0&id=7435f2c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports